/**
 * A global namespace for `mousein` event.
 */
const mouseinEvent = "mousein";
export default mouseinEvent;
